import { CustomsStateNotificationType, Declaration, DeclarationCustomsFlowType, DeclarationCustomsType, DeclarationStatus } from '@e-origin/shared';

export const canBeAmended = (declaration: Declaration, isRfiAmendment?: boolean): boolean => {
  if (declaration.virtuals?.isAmended) {
    return false;
  }

  if ([DeclarationCustomsType.DMS, DeclarationCustomsType.NL_AES].includes(declaration.customsState?.sentTo)) {
    return (
      isRfiAmendment || (declaration.generalInfo.status === DeclarationStatus.ACCEPTED && declaration.customsState?.flow === DeclarationCustomsFlowType.POST)
    );
  }

  if ([DeclarationStatus.RELEASED, DeclarationStatus.NOT_RELEASED].includes(declaration.generalInfo.status)) {
    return true;
  }

  return declaration.customsState?.flow === DeclarationCustomsFlowType.PRE && declaration.generalInfo.status === DeclarationStatus.ACCEPTED;
};

export const getDuplicationModalTitle = (declaration: Declaration, isRfiAmendment?: boolean): string => {
  const isSentToPLDA = declaration.customsState?.sentTo === DeclarationCustomsType.PLDA;

  if (canBeAmended(declaration, isRfiAmendment)) {
    return `${isSentToPLDA ? 'Regularization' : 'Amendment'} or Duplication`;
  }

  return 'Duplication';
};

export const countCustomsStateNotifications = (declaration: Declaration): { actionsPending: number; notificationsPending: number } => {
  const actionsPending =
    declaration.customsState?.notifications?.filter(({ notificationType }) => notificationType === CustomsStateNotificationType.ACTION_PENDING).length ?? 0;
  const notificationsPending =
    declaration.customsState?.notifications?.filter(
      ({ notificationType, read }) => notificationType === CustomsStateNotificationType.NOTIFICATION_PENDING && !read,
    ).length ?? 0;

  return { actionsPending, notificationsPending };
};
